import Vue from "vue";
import Vuex from "vuex";
import userVUEX from "./modules/userVUEX";

Vue.use(Vuex);
export default new Vuex.Store({
  modules: { userVUEX },
  state: {},
  getters: {},
  mutations: {},
  actions: {},
});
